import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { EventsService } from 'src/app/services/event/event.service';
import { GalleryService } from 'src/app/services/gallery/gallery.service';
import { JackpotService } from 'src/app/services/lobby/jackpot.service';
import { Navigator } from '../menu/navigator';
import { gsap } from 'gsap';
import { stringToNumber } from 'src/app/services/codeUtils';
import { ConfigService } from 'src/app/services/config/config.service';
import { AudioService } from 'src/app/services/audio/audio.service';

@Component({
  selector: 'app-game-detail',
  templateUrl: './game-detail.component.html'
})
export class GameDetailComponent implements OnInit {
  @ViewChild('gameDetail', { static: true }) gameDetail: ElementRef;

  protected betOptions: any;
  public gameLaunchData: any;
  public imagesPath: string;
  public jackpot: any[];
  public jackpotAmount: number;
  public jackpotAmount1: number;
  public jackpotAmount2: number;
  public jackpotAmount3: number;

  constructor(
    private readonly config: ConfigService,
    private readonly events: EventsService,
    private readonly galleryService: GalleryService,
    private readonly jackpotService: JackpotService,
    private readonly navigator: Navigator,
    private audioService: AudioService
  ) {
  }

  ngOnInit() {
    this.imagesPath = this.galleryService.getGamesImagePath();

    this.galleryService.gameList$.subscribe((data) => {
      this.gameLaunchData = data;
      this.updateBetOptions();
      this.getJackpotData();
    });
    
    this.animateComponent();
  }

  private updateBetOptions() {
    if (this.gameLaunchData?.extra_launch_data) {
      const extraLaunchData = JSON.parse(this.gameLaunchData.extra_launch_data);
      this.betOptions = extraLaunchData?.startBetOptions?.split(',').map(option => parseInt(option));

      // For Play N Go we want to reverse the display order of bet options to be biggest to smallest
      if (this.gameLaunchData.vendor_ident.toLowerCase() == 'playngo') {
        this.betOptions.reverse();
      }
    }
  }

  public launchGame(_index: number): any {
    this.audioService.playSound("GamePopupBetClick")
    this.events.publish("events:animation:tile:reverse");

    console.log('launchGame', this.gameLaunchData);
    if (this.gameLaunchData && this.gameLaunchData.extra_launch_data) {
      const launchData = JSON.parse(this.gameLaunchData?.extra_launch_data);

      launchData.startBetIndex = _index;

      if (this.gameLaunchData.vendor_name == "playngo") {
        // Play N Go, the parameter index we send the vendor is in reverse of the config order
        let numOptions = launchData.startBetOptions?.split(',').length + 1;
        let level = numOptions - (_index + 1); // index 1 becomes 3 and 3 becomes 1
        launchData.ctx = 'level_' + (level).toString();
      }

      this.gameLaunchData.extra_launch_data = JSON.stringify(launchData);
      return this.galleryService.launchCasinoGame(this.gameLaunchData);
    }

    return this.galleryService.launchCasinoGame(this.gameLaunchData);
  }

  async getJackpotData(): Promise<void> {
    if (this.gameLaunchData && this.gameLaunchData?.game_type_id && this.gameLaunchData?.is_jackpot) {
      const id: number = await this.getGameTypeIds();
      this.jackpot = await this.jackpotService.filteredJackpots(id);

      this.animateJackpot(this.jackpot[0]?.amt, (amount: number) => {
        this.jackpotAmount = amount;
      });

      this.animateJackpot(this.jackpot[1]?.amt, (amount: number) => {
        this.jackpotAmount1 = amount;
      });

      this.jackpotAmount2 = this.jackpot[2]?.amt;
      this.jackpotAmount3 = this.jackpot[3]?.amt;
      return;
    }
  }

  public animateJackpot(preJackpot: number, callback: (amount: number) => void): void {
    const initialAmount: number = preJackpot;
    const finalAmount: number = initialAmount;

    const startingFactor: number = stringToNumber(this.config?.getConfig()?.FEATURE_JACKPOT_ANIMATION_FACTOR) ?? 0.9;
    let startingValue: number = Math.round(initialAmount * startingFactor);
    const animationDuration: number = stringToNumber(this.config?.getConfig()?.FEATURE_JACKPOT_ANIMATION_TIMING) ?? 60;
    const numberOfUpdatesPerSecond: number = stringToNumber(this.config?.getConfig()?.FEATURE_JACKPOT_ANIMATION_INTERVAL) ?? 15;
    const numberOfUpdates: number = animationDuration * numberOfUpdatesPerSecond;
    const updateAmount: number = (finalAmount - startingValue) / numberOfUpdates;

    let updateCount = 0;

    const animationInterval = setInterval(() => {
      if (startingValue < finalAmount) {
        startingValue += updateAmount;
        callback(startingValue);
      } else {
        startingValue = finalAmount;
        callback(finalAmount);
        clearInterval(animationInterval);
      }

      if (++updateCount >= numberOfUpdates) {
        clearInterval(animationInterval);
      }
    }, 1000 / numberOfUpdatesPerSecond);
  }


  private async getGameTypeIds(): Promise<number> {
    return this.gameLaunchData?.game_type_id;
  }

  onClose = () => {
    this.events.publish("events:animation:tile:reverse");
    this.navigator.toLobby();
  }

  private animateComponent() {
    setTimeout(() => {
      const element = document.querySelector('.game-detail-master');
      if (element) {
        gsap.set(element, { rotationY: -90 });

        gsap.to(element, {
          rotationY: 0,
          delay: 0.1,
          duration: 0.3,
          ease: 'power2.inOut',
        });
      }
    });
  }

}
